<template>
  <b-form-group :label="hideLable ? '' : $t($attrs['label-text'])" :class="isHesbaClient ? 'ps-g-field' : null">
    <ValidationProvider
      ref="fieldValidator"
      v-slot="{ errors }"
      :name="$t($attrs['label-text']) || $t($attrs['name'])"
      :rules="rules || ''"
      :vid="name || $attrs['label-text'] || $attrs['name'] || ''"
      mode="eager"
    >
      <div class="q-mb-md">
        <b-input-group
          :size="attrs.size"
          class="mb-0" v-if="Object.keys($slots).length">
          <template
            v-if="$slots.prepend"
            #prepend
          >
            <slot name="prepend" />
          </template>
          <template
            v-if="$slots.append"
            #append
          >
            <slot name="append" />
          </template>
          <component
            ref="input1"
            :is="field"
            :type="type"
            :placeholder="$t(placeholder) || ''"
            :options="selectData"
            :value="itemValue"
            v-bind="attrs"
            :autocomplete="$attrs.autocomplete || 'new-password'"
            v-on="listeners"
            :dir="dir"
            :disabled="isDisabled"
            :readonly="readonly"
            :multiple="multiple"
            @input="(v) => { handelInput(v);}"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
            @option:selected="(v) => {$emit('change', v);}"
            @keyup.enter.prevent=""
            :state="errors.length > 0 ? false : null"
            v-b-tooltip.hover.v-danger
            :title="toolTipError ? errors[0] || '' : ''"
          >
            <template v-if="$attrs.field === 'select'" #no-options>
              {{ $t('Sorry, no matching options') }}
            </template>
          </component>
        </b-input-group>
        <component v-else
            ref="input2"
            :is="field"
            :type="type"
            :placeholder="$t(placeholder) || ''"
            :options="selectData"
            :value="itemValue"
            :name="$attrs['name'] || $attrs['label-text'] || ''"
            :multiple="multiple"
            v-bind="attrs"
            v-on="listeners"
            :dir="dir"
            :disabled="isDisabled"
            :readonly="readonly"
            @input="(v) => { handelInput(v);}"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
            @wheel="$event.target.blur()"
            @option:selected="(v) => {$emit('change', v);}"
            :state="errors.length > 0 ? false : null"
            v-b-tooltip.hover.v-danger
            :title="toolTipError ? errors[0] || '' : ''"
          >
            <template v-if="$attrs.field === 'select'" #no-options>
              {{ $t('Sorry, no matching options') }}
            </template>
          </component>
        <small :class="{ 'd-none': !$attrs['name'] && !$attrs['label-text'] || toolTipError }" class="text-danger">{{ errors[0] }}</small>
      </div>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },
  props: {
    options: {
      type: [Array, Object, String],
      default: () => [],
    },
    dir: {
      type: String
    },
    value: {
      type: [Number, String, Object, Array],
      required: false,
      default: null,
    },
    disabled: {
      type: [Number, String, Boolean],
      default: false,
    },
    readonly: {
      type: [Number, String, Boolean],
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    itemId: {
      type: String,
      default: 'id',
    },
    multiple: {
      type: [Number, Boolean],
      default: false,
    },
    toolTipError: {
      type: [Number, Boolean],
      default: false,
    },
    hideLable: {
      type: [Number, Boolean],
      default: false
    },
  },
  emits: ['update:value', 'input', 'change'],
  setup(props, context) {
    let { attrs } = context;
    const {
      name, placeholder, type, lookup,
    } = attrs;

    let { field } = attrs;

    if (field === 'select') field = 'v-select';
    else field = 'b-form-input';

    attrs = Object.entries(attrs).reduce((obj, val) => {
      /* eslint-disable prefer-destructuring */
      if (['field', 'name', 'placeholder', 'type', 'lookup', ...Object.keys(props)].indexOf(val[0]) === -1) obj[val[0]] = val[1];
      return obj;
    }, {});

    const listeners = Object.entries(context.listeners).reduce((obj, val) => {
      if (['update:value', 'input', 'change'].indexOf(val[0]) === -1) obj[val[0]] = val[1];
      return obj;
    }, {});

    return {
      name,
      type,
      placeholder,
      attrs,
      field,
      lookup,
      listeners,
    };
  },
  data() {
    return {
      selectData: [],
      itemValue: '',
      isFocus: false,
      isDirty: false,
    };
  },
  watch: {
    options(newVal) {
      this.handeloptions(newVal);
    },
    value(newVal) {
      this.handelValue(newVal);
    },
  },
  computed: {
  isDisabled() {
    return this.toBoolean(this.disabled);
  },
  isReadonly() {
    return this.toBoolean(this.readonly);
  },
  isMultiple() {
    return this.toBoolean(this.multiple);
  },
  isToolTipError() {
    return this.toBoolean(this.toolTipError);
  },
  isHideLable() {
    return this.toBoolean(this.hideLable);
  },
},
  mounted() {
    this.handeloptions();
    this.handelValue(this.type === 'number' && this.name !== 'discountPercentage' && this.name !== 'additionalNumber' && this.name !== 'code' && this.name !== 'scalesCode' && this.name !== 'circumference' ? this.fraction(this.value) : this.value);
  },
  methods: {
    toBoolean(value) {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return value.toLowerCase() === 'true';
    return Boolean(value);
  },
    handeloptions() {
      if (Array.isArray(this.options)) this.selectData = this.options;
      else {
        this.$store.dispatch('lookups/getEntity', this.options).then((data) => {
          this.selectData = data;
        });
      }
      this.handelValue(this.value);
    },
    handelValue(newVal) {
      if (this.$attrs.field === 'select') {
        if (!this.multiple) {
          this.itemValue = this.selectData.find((item) => item[this.itemId] === newVal) || null;
        } else {
          this.itemValue = newVal;
        }
      } else this.itemValue = newVal;
    },
    handelInput(val, isWriteAction = true) {
      this.isDirty = isWriteAction;
      if (this.$attrs.field === 'select') {
        if (!this.multiple) {
          val = val ? val[this.itemId] : null;
        }
      }
      this.$emit('update:value', this.type === 'number' ? parseFloat(val) || 0 : val);
      this.$emit('input', this.type === 'number' ? parseFloat(val) || 0 : val);
      if (this.$route.name !== 'items-category') {
      this.$emit('update:value', this.type === 'number' && this.name === 'code' && this.name === 'mainUnitBarcode' && this.name === 'scalesCode' ? parseFloat(val).toString() : val);
      this.$emit('input', this.type === 'number' && this.name === 'code' && this.name === 'mainUnitBarcode' && this.name === 'scalesCode' ? parseFloat(val).toString() : val);
      } else {
      this.$emit('update:value', this.type === 'number' && this.name === 'code' && this.name === 'mainUnitBarcode' && this.name === 'scalesCode' ? val : val);
      this.$emit('input', this.type === 'number' && this.name === 'code' && this.name === 'mainUnitBarcode' && this.name === 'scalesCode' ? val : val);
      }
    },
    onFocus() {
      if (this.$route.name !== 'items-category') {
        if (this.type === 'number') this.itemValue = parseFloat(this.itemValue);
      }
    },
    onBlur() {
      if (this.$route.name !== 'items-category') {
      if (this.type === 'number' && this.name !== 'discountPercentage' && this.name !== 'additionalNumber' && this.name !== 'code' && this.name !== 'scalesCode' && this.name !== 'circumference' && this.name !== 'mainUnitBarcode') this.itemValue = this.fraction(this.itemValue);
      if (this.type === 'number' && this.name === 'code' && this.name === 'mainUnitBarcode' && this.name === 'scalesCode') this.itemValue = (this.itemValue).toString();
      }
    },
    onChange(v) {
      this.$emit('change', v);
      if (this.type === 'number' && this.name !== 'discountPercentage' && this.name !== 'additionalNumber' && this.name !== 'code' && this.name !== 'scalesCode' && this.name !== 'circumference' && this.name !== 'mainUnitBarcode') this.itemValue = parseFloat(v).toFixed(this.currentBranch.decimalDigits);
      if (this.type === 'number' && this.name === 'code' && this.name === 'mainUnitBarcode' && this.name === 'scalesCode') this.itemValue = (this.itemValue).toString();
    },
  },
};
</script>
